import CustomImage from "../../CustomImage";
import UpdateStudentRoundStatus from "../UpdateStudentRoundStatus";

export const RoundStudentsColumns = [
    {
        accessorKey: "profilePic",
        header: "Profile Pic",
        cell: ({ row }) => {
            const student = row.original;
            return <CustomImage className="w-12 h-12 object-contain rounded-full" src={student.profilePic} alt="student" section="student"   />
        }
    },
    {
        accessorKey: "name",
        header: "Name",
    },
    {
        accessorKey: "rollNo",
        header: "Roll No",
    },
    {
        accessorKey: "branch",
        header: "Branch",
    },
    {
        accessorKey: "graduationYear",
        header: "Graduation Year",
    },
    {
        accessorKey: "cgpa",
        header: "GPA",
    },
    {
        accessorKey: "placementStatus",
        header: "Placement Status",
    },
    {
        accessorKey: "dreamPlacement",
        header: "Dream Placement",
        cell: ({ row }) => {
            const student = row.original
            return student.dreamPlacement ? <p>Yes</p> : <p>No</p>
        }
    },
    {
        accessorKey: "interestedInPlacements",
        header: "Interested In Placements",
        cell: ({ row }) => {
            const student = row.original
            return student.interestedInPlacements ? <p>Yes</p> : <p>No</p>
        }
    },
    {
        accessorKey: "currentStatus",
        header: "Status",
    },
    {
        accessorKey: "phoneNumber",
        header: "Phone Number",
    },
    {
        accessorKey: "email",
        header: "Email",
    },
    {
        id: "actions",
        header: "Actions",
        cell: ({ row }) => {
            const student = row.original

            return <UpdateStudentRoundStatus student={student} />
        }
    }

]